<dx-date-box
  type="time"
  displayFormat="shorttime"
  #dateInput
  [attr.name]="nameString"
  [attr.tabindex]="tabIndexValue"
  placeholder="Short time"
  class="focusable"
  [(value)]="time"
  (ngModelChange)="changeModelState()"
  (blur)="onblurEvent()"
  [required]="requiredValue"
  [readonly]="disabledValue"
  [min]="minValue"
  openOnFieldClick="true"
  (onFocusOut)="onblurEvent()"
  (onFocusIn)="onFocusIn()"
  (onInitialized)="onInitialized.emit($event)"
  [disabled]="disabledValue">
</dx-date-box>
